export enum GSMSubdomain {
  HTZ = "htz",
  RLT = "rlt",
  Textblocks = "textblocks",
  VBS = "vbs",
}
